import {
   Reset_password_Remove , Reset_PassWord_Failed , Reset_PassWord_Loading , Reset_PassWord_Success
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    status: null,
    message:null ,
  };
  
  export const ResetPasswordFirstLoginReducer = (
    state = initialState,
    action: { type: any; loading:boolean , payload: any, error: any }
  ) => {
    switch (action.type) {
      case Reset_PassWord_Loading:
        return {
          ...state,
          loading: action.loading,
        };
      case Reset_PassWord_Success:
        return {
          ...state,
          loading: false,
          status: action.payload.code,
          message:action.payload.message ,
          error: null,
        };
      case Reset_PassWord_Failed:
        return {
          ...state,
          loading: false,
          status: null,
          message:null , 
          error: action.error,
        };
        case Reset_password_Remove : 
        return {
          ...state, 
          loading: false,
          status: null,
          message:null , 
          error: null ,

        }
      default:
        return state;
    }
  };
  